import { observer } from "mobx-react";
import React, { useState } from "react";
import {
  ActionIcon,
  Button,
  Text,
  Divider,
  Modal,
  Stack,
  TextInput,
  Group,
  Alert,
} from "@mantine/core";

import { Cubby } from "../../stores/Cubby";
import { IconAlertTriangle, IconTrash } from "@tabler/icons-react";
import { TextWithInfo } from "./textWithInfo";
import { MODALS } from "../../helpers/constants";
import { TextWithInfoAndIcon } from "../dataDisplay/textWithInfoAndIcon";
import { ARTICLES } from "../../docs/docsIndex";

const DestroyCubby = observer(({ cubby }: { cubby: Cubby }) => {
  const [confirmationText, setConfirmationText] = useState("");

  return (
    <Modal
      opened={cubby.currentModal === MODALS.DESTROY_CUBBY}
      onClose={() => cubby.setModal(null)}
      title={
        <TextWithInfoAndIcon
          text="Delete This Node"
          articleSlug={ARTICLES.DELETING_YOUR_NODE.slug}
          icon={<IconTrash size={24} />}
          cubby={cubby}
          textSize="lg"
        />
      }
    >
      <>
        {!cubby.isAllowedToDestroy && (
          <Text>
            You will be able to delete this node once you close all of your
            channels and withdraw all your funds.
          </Text>
        )}

        {cubby.isAllowedToDestroy && (
          <Stack>
            <Text>
              Are you sure you want to delete this node? This action cannot be
              undone.
            </Text>
            {cubby.totalOfAllBalances > 0 && (
              <Text>
                You have a total of {cubby.totalOfAllBalances.toLocaleString()}{" "}
                satoshis in this Node. These funds will be PERMANENTLY LOST.
              </Text>
            )}
            {cubby.onchainAddresses?.data.length > 0 && (
              <Alert color="red" title="Confirm Deletion" mt="md">
                You have made {cubby.onchainAddresses?.data.length} onchain
                addresses. Any funds sent to these addresses in the future will
                be PERMANENTLY LOST.
              </Alert>
            )}

            <TextInput
              label="Type 'destroy node' to confirm"
              placeholder="destroy node"
              value={confirmationText}
              onChange={(event) =>
                setConfirmationText(
                  event.currentTarget.value.toLocaleLowerCase()
                )
              }
            />

            <Button
              variant="filled"
              color="red"
              onClick={() => {
                cubby.cubbyLife("destroy_now");
                cubby.setModal(null); // Close modal after action
              }}
              disabled={confirmationText !== "destroy node"}
            >
              Destroy Now
            </Button>
          </Stack>
        )}
      </>
    </Modal>
  );
});

export default DestroyCubby;
